<div class="background-color2 md:h-full fixed bottom-0 md:min-h-screen z-10 lg:w-72 md:w-64 md:pt-24 md:pb-5 md:mt-0 overflow-x-scroll md:overflow-x-hidden">
    <ul class="flex flex-row md:flex-col">
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/dashboard" routerLinkActive="active" #overview="routerLinkActive">
          <img class="h-6 w-6" src="assets/overview.webp" alt="" *ngIf="overview.isActive">
          <img class="h-7 w-7" src="assets/overview-1.webp" alt="" *ngIf="!overview.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>Dashboard</span> 
        </a>
      </li>
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/user-management" routerLinkActive="active" #user="routerLinkActive">
          <img class="h-6 w-6" src="assets/user.webp" alt="" *ngIf="user.isActive">
          <img class="h-7 w-7" src="assets/user-1.webp" alt="" *ngIf="!user.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>User Management</span>
        </a>
      </li>
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/genre-management" routerLinkActive="active" #genre="routerLinkActive">
          <img class="h-6 w-6" src="assets/genre.webp" alt="" *ngIf="genre.isActive">
          <img class="h-7 w-7" src="assets/genre-1.webp" alt="" *ngIf="!genre.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>Genre Management</span>
        </a>
      </li>
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/video-management" routerLinkActive="active" #video="routerLinkActive"> 
          <img class="h-6 w-6" src="assets/video.webp" alt="" *ngIf="video.isActive">
          <img class="h-7 w-7" src="assets/video-1.webp" alt="" *ngIf="!video.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>Video Management</span>
        </a>
      </li>
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/top 4te" routerLinkActive="active" #top="routerLinkActive">
          <img class="h-6 w-6" src="assets/top.webp" alt="" *ngIf="top.isActive">
          <img class="h-7 w-7" src="assets/top-1.webp" alt="" *ngIf="!top.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>View Top 4te's</span>
        </a>
      </li>
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/report-management" routerLinkActive="active" #report="routerLinkActive">
          <img class="h-6 w-6" src="assets/report.webp" alt="" *ngIf="report.isActive">
          <img class="h-7 w-7" src="assets/report-1.webp" alt="" *ngIf="!report.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>Report Management</span>
        </a>
      </li>
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/terms-conditions" routerLinkActive="active" #terms="routerLinkActive">
          <img class="h-6 w-6" src="assets/terms.webp" alt="" *ngIf="terms.isActive">
          <img class="h-7 w-7" src="assets/terms-1.webp" alt="" *ngIf="!terms.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>Terms & Conditions</span>
        </a>
      </li>
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/database-access" routerLinkActive="active" #database="routerLinkActive"> 
          <img class="h-6 w-6" src="assets/database.webp" alt="" *ngIf="database.isActive">
          <img class="h-7 w-7" src="assets/database-1.webp" alt="" *ngIf="!database.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>Database Access</span>
        </a>
      </li>
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/banner-management" routerLinkActive="active" #banner="routerLinkActive">
          <img class="h-6 w-6" src="assets/banner.webp" alt="" *ngIf="banner.isActive">
          <img class="h-7 w-7" src="assets/banner-1.webp" alt="" *ngIf="!banner.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>Banner Management</span>
        </a>
      </li>
      <li class='nav-link md:py-3 pr-4 md:pr-0'>
        <a class="nav-text md:p-4 md:flex-row" routerLink="../pages/contact-us" routerLinkActive="active" #contact="routerLinkActive">
          <img class="h-6 w-6" src="assets/contact.png" alt="" *ngIf="!contact.isActive">
          <img class="h-7 w-7" src="assets/contact-1.png" alt="" *ngIf="contact.isActive">
          <span class='md:ml-3 whitespace-no-wrap block md:inline-block text-sm md:text-lg'>Contact Us</span>
        </a>
      </li>
    </ul>
  </div>